module.exports = __webpack_public_path__ + "static/media/Icon_Favorite.ad025be7.svg";